export const openSidebar = () => ({ type: "OPEN_SIDEBAR" });

export const closeSidebar = () => ({ type: "CLOSE_SIDEBAR" });

export const syncingStart = () => ({ type: "SYNCING_START" });

export const syncSuccess = () => ({ type: "SYNC_SUCCESS" });

export const syncFail = () => ({ type: "SYNC_FAIL" });
